<template>
  <div>
    <XDateType
      v-if="showDateType"
      :label="labelIcon(reactionIcon)"
      :icon="reactionIcon"
      :date="reaction.relativeDate"
    />

    <XCard>
      <div
        v-if="isOembed"
        slot="header"
      >
        <img
          v-if="!isOembedPlaying"
          :src="reaction.url"
          :class="$style['oembed-cover']"
          @click="playOembed"
        >
        <div
          v-else
          :class="$style.oembed"
          :style="{ paddingBottom: oembedRatio + '%' }"
        >
          <div v-html="reaction.data.oembed.html" />
        </div>
      </div>

      <div
        v-if="isEmbed"
        slot="header"
      >
        <XEmbedBase :srcdoc="reaction.data.thumbnail">
          <div :class="$style.spinner">
            <XMediaSpinner />
          </div>
        </XEmbedBase>
      </div>

      <a
        v-else-if="isLink"
        slot="header"
        :href="reaction.data.url"
        target="_blank"
        class="no-underline"
      >
        <img
          :src="reaction.url"
          class="block w-full"
        >
      </a>

      <div
        v-else
        slot="header"
      >
        <XVideoPlayer
          v-if="isVideo"
          :playsinline="true"
          :options="playerOptions"
        />

        <silentbox-single
          v-else
          :src="reaction.url"
        >
          <img
            :src="reaction.url"
            class="block w-full"
          >
        </silentbox-single>
      </div>

      <XReactionFooter
        v-if="shareChannels"
        :reaction="reaction"
        :shareChannels="shareChannelsWithoutDownload"
        :shareMessage="shareMessage"
        :shareHashtags="shareHashtags"
        :shareDescription="shareDescription"
        :allowExpressions="allowExpressions"
      />
    </XCard>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css'

import { videoPlayer } from 'vue-video-player'

import ReactionMixin from './ReactionMixin'

export default {
  mixins: [
    ReactionMixin
  ],

  components: {
    'XVideoPlayer': videoPlayer
  },

  data () {
    return {
      playerOptions: {
        language: 'es',
        sources: [{
          type: 'video/mp4',
          src: this.reaction.url
        }]
      },
      isOembedPlaying: false,
      shareChannelsWithoutDownload: this.shareChannels
        ? this.shareChannels.filter(value => {
          return value !== 'download'
        })
        : []
    }
  },

  computed: {
    reactionIcon () {
      if (this.reaction.data && this.reaction.data.timelineIcon) {
        return 'fa/light/' + this.reaction.data.timelineIcon
      }

      return 'fa/light/bullhorn'
    },

    isLink () {
      return this.reaction.data && this.reaction.data.url
    },

    isVideo () {
      return this.reaction.url.includes('mp4')
    },

    isOembed () {
      return this.reaction.data && this.reaction.data.oembed
    },

    isEmbed () {
      return this.reaction.data && this.reaction.data.thumbnailType === 'embed'
    },

    oembedRatio () {
      return this.reaction.data
        ? this.reaction.data.oembed.height / this.reaction.data.oembed.width * 100
        : 56.25
    }
  },

  methods: {
    playOembed () {
      this.isOembedPlaying = true
    }
  }
}
</script>

<style
  lang="scss"
  module
>
.oembed-cover {
  width: 100%;
  cursor: pointer;
}

.oembed {
  overflow: hidden;
  position: relative;
  height: 0;
  background: #000;
}

.oembed iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}

.spinner {
  @apply relative;

  min-height: 100px;

  & > div {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
